import {NgModule, ModuleWithProviders} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {WizardRoutingModule} from './wizard-routing.module';

// MODULES
const MODULES = [
    SharedModule,
    WizardRoutingModule
];

// MODULES_WITH_PROVIDERS
const MODULES_WITH_PROVIDERS: ModuleWithProviders[] = [];

// COMPONENTS
import {AngularWizardComponent} from './components/angular-wizard/wizard.component';
import {AngularWizardStepComponent} from './components/angular-wizard/wizard-step.component';
import {MobileWizardComponent} from './components/mobile-wizard/mobile-wizard.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';

// ENTRY COMPONENTS
const ENTRY_COMPONENTS = [];

// COMPONENTS
const COMPONENTS = [
    ...ENTRY_COMPONENTS,
    AngularWizardComponent,
    AngularWizardStepComponent,
    MobileWizardComponent
];

// EVENT EMITTERS
const EVENT_EMITTERS = [];

// SERVICES
const SERVICES = [];

// DIRECTIVES
const DIRECTIVES = [];

// PIPES
const PIPES = [];

@NgModule({
    imports: [
        ...MODULES,
        ...MODULES_WITH_PROVIDERS,
        LazyLoadImageModule
    ],
    declarations: [
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES
    ],
    providers: [
        ...SERVICES,
        ...EVENT_EMITTERS
    ]
})
export class WizardModule {
}
